import React from 'react';
import { Content } from '../../types/content';

interface MediaContentProps {
  content: Content;
}

export default function MediaContent({ content }: MediaContentProps) {
  if (content.type === 'video') {
    return (
      <div className="relative aspect-video rounded-lg overflow-hidden">
        <video
          src={content.videoUrl}
          poster={content.thumbnailUrl}
          className="w-full h-full object-cover"
          controls
        />
      </div>
    );
  }

  if (content.type === 'article' && content.coverImage) {
    return (
      <img
        src={content.coverImage}
        alt={content.title}
        className="w-full aspect-[2/1] object-cover rounded-lg"
      />
    );
  }

  if (content.type === 'post' && content.attachments?.length) {
    const imageAttachments = content.attachments.filter(a => a.type === 'image');
    if (imageAttachments.length === 1) {
      return (
        <img
          src={imageAttachments[0].url}
          alt=""
          className="w-full rounded-lg"
        />
      );
    }
    if (imageAttachments.length > 1) {
      return (
        <div className="grid grid-cols-2 gap-1.5">
          {imageAttachments.map((img, i) => (
            <img
              key={i}
              src={img.url}
              alt=""
              className="w-full h-32 object-cover rounded-lg"
            />
          ))}
        </div>
      );
    }
  }

  return null;
}